<template>
    <div class="modal" tabindex="-1" role="dialog" id="muven-product-store-channel-status-toggle-modal">
        <div class="modal-dialog modal-lg" role="document" v-if="modalOpened">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Gerenciar envio por canal</h5>
                </div>

                <div class="modal-body">
                    <div>
                        <div class="row">
                            <div class="col-12">
                                <div class="muven-tip tip-danger mb-3">
                                    <fa icon="info" class="tip-icon" />
                                    <p>Ao desmarcar o produto ou suas variações o vínculo Muven x Canal será <b>REMOVIDO</b> e o produto será <b>EXCLUÍDO</b>. Portanto, apenas clique em "Gravar", quando tiver certeza do que está fazendo.</p>
                                </div>
                            </div>
                        </div>

                        <div class="row channel-options">
                            <div class="col-12 form-group">
                                <label>Canal</label>
                                <multiselect
                                    v-model="chosenChannel"
                                    :options="channelList"
                                    :multiple="false"
                                    :show-labels="false"
                                    :allow-empty="false"
                                    @select="selectChannel"
                                    placeholder=""
                                    label="name"
                                    track-by="id" />
                                <small class="text-muted">Devido a limitação das APIs de cada canal, esta funcionalidade não está disponível para todas as integrações.</small>
                            </div>
                        </div>

                        <div class="row product-labels-container">
                            <div class="col-4">
                                <label>Nome</label>
                            </div>

                            <div class="col-8">
                                <label class="text-right">Enviar para {{chosenChannel.name}}</label>
                            </div>
                        </div>

                        <div class="status-toggle-container">
                            <div class="row product-info-container">
                                <div class="col-9">
                                    <p class="product-name">{{productStoreChannelStatusForm.product.name}}</p>
                                </div>

                                <div class="col-3" 
                                    v-for="(productStoreChannel, index) in productStoreChannelStatusForm.storeChannelList" :key="index"
                                    v-show="shouldShowColumn(productStoreChannel)">
                                    <SwitchToggle 
                                        :prop-check="productStoreChannel.isActive"
                                        @updated="isActiveParentHandler(productStoreChannel, !productStoreChannel.isActive)"
                                    />
                                </div>
                            </div>

                            <div class="row variation-container" 
                                v-for="(variation, index) in productStoreChannelStatusForm.variations" :key="index">
                                <div class="col-9">
                                    <p class="variation-name">{{variation.getVariationsStringified()}}</p>
                                </div>

                                <div class="col-3" 
                                    v-for="(variationStoreChannel, index) in variation.storeChannelList" :key="index"
                                    v-show="shouldShowColumn(variationStoreChannel)">
                                    <SwitchToggle 
                                        :prop-check="variationStoreChannel.isActive"
                                        @updated="isActiveVariationHandler(variation, variationStoreChannel, !variationStoreChannel.isActive)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <!-- <button type="button" 
                        class="btn btn-primary" 
                        :disabled="updatingStatus"
                        @click="updateProductStoreChannelStatus(productStoreChannelStatusForm)">                                    
                        Gravar

                        <Loading v-show="updatingStatus" />
                    </button> -->

                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        @click="closeModal()">                                    
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ProductStoreChannelStatusFormModel } from '../models/ProductStoreChannelStatusFormModel'
import modalService from '@/utils/services/ModalService'
import productService from '../services/ProductService'
import channelService from '../../channel/services/ChannelService'
import { ChannelModel } from '../../channel/models/ChannelModel'
import { mapState } from 'vuex'

const ID_PRODUCT_STORE_CHANNEL_STATUS_TOGGLE_MODAL = '#muven-product-store-channel-status-toggle-modal'

export default {
    name: 'ProductStoreChannelStatusToggleCmp',
    data() {
        return {
            modalOpened: false,
            updatingStatus: false,
            channelList: [],
            chosenChannel: new ChannelModel(),
            productStoreChannelStatusForm: new ProductStoreChannelStatusFormModel(),
        }
    },
    methods: {
        async updateProductStoreChannelStatus(productStoreChannelStatusForm) {
            this.updatingStatus = true

            try {
                await productService.updateProductStoreChannelStatus(productStoreChannelStatusForm.getStatusList())
                this.closeModal()
                this.$floatingAlert.success({
                    message: `O status de envio do produto <b>${productStoreChannelStatusForm.product.name}</b> para os canais foi atualizado.`
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.updatingStatus = false
        },
        async isActiveParentHandler(productStoreChannel, info) {
            productStoreChannel.isActive = info

            const productStatus = this.productStoreChannelStatusForm.getProductStatus(productStoreChannel)

            try {
                await productService.updateProductStoreChannelStatus(productStatus)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                });
            }
        },
        async isActiveVariationHandler(variation, variationStoreChannel, info) {
            variationStoreChannel.isActive = info

            const variationStatus = this.productStoreChannelStatusForm.getVariationStatus(variation, variationStoreChannel)

            try {
                await productService.updateProductStoreChannelStatus(variationStatus)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                });
            }
        },
        async openModal(shallowProduct) {
            this.modalOpened = false

            const result = await Promise.all([
                productService.getProductById(shallowProduct.id), 
                channelService.getChannels()
            ])
            const product = result[0]
            this.channelList = result[1].filter((c) => {
                return c.isTray() || c.isB2W() || c.isNuvemShop() || c.isWooCommerce()
            })

            this.productStoreChannelStatusForm = new ProductStoreChannelStatusFormModel(product, this.channelList, this.subscriber)
            this.selectChannel(this.channelList[0])

            modalService.show(ID_PRODUCT_STORE_CHANNEL_STATUS_TOGGLE_MODAL)

            this.modalOpened = true
        },
        closeModal() {
            modalService.hide(ID_PRODUCT_STORE_CHANNEL_STATUS_TOGGLE_MODAL)
        },
        selectChannel(ch) {
            this.chosenChannel = ch
        },
    },
    computed: {
        ...mapState({
            suscriber: state => state.suscriber,    
        }),
        shouldShowColumn() {
            return (storeChannel) => {
                return this.chosenChannel.id === storeChannel.channel.id
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.product-info-container,
.variation-container {
    &:hover {
        background-color: var(--surface-2);
    }
}

.status-toggle-container {
    max-height: 350px;
    overflow-x: hidden;
    overflow-y: auto;
    margin: 0;
    padding: 0 15px;

    .product-info-container {
        border: 1px solid var(--border);

        .product-name {
            padding-top: 12px;
            padding-bottom: 12px;
        }
    }

    .variation-container {
        border: 1px solid var(--border);
        border-top: none;

        &:nth-of-type(even) {
            background-color: color-mix(in srgb, var(--text-strong) 5%, transparent);
        }

        .variation-name {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>